export enum DegreeOfDifficulty {
    None = 0,
    DifficultLevel = 1,
    MidLevel = 2,
    EasyLevel = 3,
}
